import { REFRESH_TOKEN, TOKEN, USER_ID } from 'constants/localStorage';
import { broadcastSignOut } from 'components/CallScribe/popupChannel';
import { forgetLiveCallLease } from 'components/CallScribe/liveCallLease';
import { dropPopupSession, heldPopupSession } from 'utils/popupSession';

export const sessionToken = (): string | null =>
  heldPopupSession()?.accessToken ?? localStorage.getItem(TOKEN);

export const sessionUserId = (): string | null =>
  heldPopupSession()?.userId ?? localStorage.getItem(USER_ID);

export const clearSession = (): void => {
  if (heldPopupSession()) {
    dropPopupSession();
    return;
  }
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(USER_ID);
};

export const signOut = (): void => {
  clearSession();
  forgetLiveCallLease();
  broadcastSignOut();
};
